// import React from 'react';
import {useState} from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"

//画像の読み込み
import IcoCalenderGray from '../../../assets/images/ico_calender_gray.svg';

function Calender(props:any) {

    const [startDate, setStartDate] = useState<Date|null>(null)
    const [endDate, setEndDate] = useState<Date|null>(null)

    /**
     * 値を検索用にフォーマット　dateがnullでなければ、値をフォーマットする　nullであれば''
     * @param date 変換するdate値
     * @returns 変換後の値
     */
    const dateFormat=(date:Date|null)=>{
        const outputDate=date?`${date.getFullYear()}-${( '00' + (date.getMonth()+1) ).slice( -2 )}-${( '00' + date.getDate() ).slice( -2 )}`:''
        return outputDate
    }
    
    const startDateChange=(date:Date|null)=>{
        //stateに設定
        setStartDate(date)

        //値をフォーマットの上、親コンポーネントに送信
        props.onChangeValue(dateFormat(date),dateFormat(endDate))
    }

    const endDateChange=(date:Date|null)=>{
        //stateに設定
        setEndDate(date)

        //値をフォーマットの上、親コンポーネントに送信
        props.onChangeValue(dateFormat(startDate),dateFormat(date))
    }

    return(
        <div className="form__item-input-inner form__item-input-inner--calender">
            <div className="form__item-calender">
                <DatePicker selected={startDate} onChange={startDateChange} dateFormat="yyyy/MM/dd" showDisabledMonthNavigation></DatePicker>
                <div className="form__item-calender-icon">
                    <img src={IcoCalenderGray} alt="" />
                </div>
            </div>
            <div className="form__item-calender">
                <DatePicker selected={endDate} onChange={endDateChange} dateFormat="yyyy/MM/dd" showDisabledMonthNavigation></DatePicker>
                <div className="form__item-calender-icon">
                    <img src={IcoCalenderGray} alt="" />
                </div>
            </div>
        </div>
    );
}


export default Calender;